export const ARTIST_DIMENSION = 150;
export const ARTIST_MARGIN = 15;
